import { apiStatus, DEFAULT_AWL_SUPPORT_CENTER_URL } from '@va/constants';
import { useAddNotification } from '@va/dashboard/util-hooks';
import { useLocale, useTranslate } from '@va/localization';
import { CustomDomainsApi } from '@va/shared/api/custom-domains';
import { getAgencyUi } from '@va/standalone/shared/actions';
import { getApiRequestStatus, selectAgencyId } from '@va/standalone/shared/selectors';
import { CustomSubdomainComponent } from '@va/ui/components/white-label-customisation';
import Config from 'Config';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAgencyCustomDashboardDomains } from '../shared/useAgencyCustomDomains';
import { useGetLiveAgencyDomain } from './useGetLiveAgencyDomain';

const DEFAULT_DOMAIN = Config.customDomain.slice(1);
const domains = [{ label: DEFAULT_DOMAIN, value: 0 }];

const CustomSubdomainContainer = () => {
  const { showErrorNotification } = useAddNotification();
  const dispatch = useDispatch();
  const translate = useTranslate();
  const { locale } = useLocale();

  const domainSupportUrl = useMemo(() => `${DEFAULT_AWL_SUPPORT_CENTER_URL}/${locale}/support`, [locale]);

  const agencyUiStatus = useSelector((state) => getApiRequestStatus(state, 'getAgencyUi'));
  const agencyId = useSelector(selectAgencyId);
  const isCustomDomainLoading = agencyUiStatus === apiStatus.IN_PROGRESS;

  const { mutate: mutateCustomDomainsList } = useAgencyCustomDashboardDomains();

  const onSaveDomain = useCallback(
    async (domainUrl: string) => {
      try {
        if (!agencyId) return;
        await CustomDomainsApi.createOrUpdateAgencyCustomSubdomain({
          agencyId: agencyId,
          customUrl: domainUrl,
        });
        dispatch(getAgencyUi());
        mutateCustomDomainsList();
      } catch (error) {
        console.error(error);
        showErrorNotification(undefined, CustomDomainsApi.extractApiErrorMessage(error, translate));
      }
    },
    [agencyId, dispatch, mutateCustomDomainsList, showErrorNotification, translate],
  );

  const { customUrl = '', domainType } = useGetLiveAgencyDomain();

  return (
    <CustomSubdomainComponent
      customUrl={domainType === 'custom-subdomain' ? customUrl : ''}
      onSubmit={onSaveDomain}
      saveButtonProps={{
        disabled: isCustomDomainLoading,
      }}
      domains={domains}
      supportCenterUrl={domainSupportUrl}
      isCustomDomainLoading={isCustomDomainLoading}
    />
  );
};

export default CustomSubdomainContainer;
